export const SET_INVOICE_INFO = 'SET_INVOICE_INFO';
export const DELETE_INVOICE_INFO = 'DELETE_INVOICE_INFO';
export const SET_PAYMENT_PROCESSED = 'SET_PAYMENT_PROCESSED';